export default class Form {
    constructor(form) {
        this.form = form;
        this.inputList = this.getInputList();
        this.formdata = {
            first_name: "",
            last_name: "",
            email: "",
            tel: "",
            message: "",
            privacy_policy: "",
        };
    }
    validate() {
        this.form.classList.add("was-validated");
        return this.form.checkValidity();
    }
    getInputList() {
        return [...this.form.querySelectorAll(".form-data")];
    }
    formatInputData() {
        this.inputList.forEach((input) => {
            this.formdata = Object.assign(Object.assign({}, this.formdata), { [input.id]: input.type !== "checkbox" ? input.value : input.checked });
        });
    }
}
